'use client';

import {
  TableIcon,
  SearchIcon,
  HelpCircleIcon,
  SettingsIcon,
  LayoutDashboardIcon,
  ClipboardListIcon,
  UsersIcon,
  FileTextIcon,
  HistoryIcon,
  BriefcaseIcon,
  MailIcon,
  BuildingIcon,
  StarIcon,
  CalendarIcon,
  InboxIcon,
  ListIcon,
  ArchiveIcon,
  FolderIcon,
  FolderLockIcon,
  SquareUserIcon,
  FileStackIcon,
  AudioLinesIcon,
  UserPlusIcon,
  type LucideIcon
} from 'lucide-react';

// Map of icon names to icon components.
//
// Registration is mandatory and fails SILENTLY: `IconMapper` renders `null`
// for an unknown name, so a nav item pointing at an unregistered icon ships a
// label with no glyph and no error anywhere. Every `icon` string in
// `components/app-sidebar/navigation-data.ts` must appear here.
const iconMap: Record<string, LucideIcon> = {
  TableIcon,
  SearchIcon,
  HelpCircleIcon,
  SettingsIcon,
  LayoutDashboardIcon,
  ClipboardListIcon,
  UsersIcon,
  FileTextIcon,
  HistoryIcon,
  BriefcaseIcon,
  MailIcon,
  BuildingIcon,
  StarIcon,
  CalendarIcon,
  InboxIcon,
  ListIcon,
  ArchiveIcon,
  FolderIcon,
  FolderLockIcon,
  SquareUserIcon,
  FileStackIcon,
  AudioLinesIcon,
  UserPlusIcon
};

interface IconMapperProps {
  iconName?: string;
  className?: string;
}

export function IconMapper({ iconName, className }: IconMapperProps) {
  if (!iconName || !iconMap[iconName]) {
    return null;
  }

  const Icon = iconMap[iconName];
  return <Icon className={className} />;
}
